export const checksums = {
  "saferGamblingQasBrand": "v3.5.0--8hnfP64Qefq7XkHc5kBsEABQqsaXeOU9Tz_ZeJMWsMQ",
  "saferGamblingPathsBrand": "v3.5.0--V8aCm-2pgU046RQEgyojNPAzloM773quBjimmvgkyZc",
  "saferGamblingBrand": "v3.5.0--qqfQllZxxAqmVleX8sQddlx94O0Hsp-Ky6q8op09HQ0",
  "gamePagesBrand": "v3.5.0--zQo9snQoWpNOlykgQc45pbk-pWDq9yBJ4kM4n-qnVJo",
  "blogsTagsBrand": "v3.5.0--KQtulL9O123ldTpFGWPr0TF4hX1ncu--DsIaKuS4ueM",
  "pressTagsBrand": "v3.5.0--5sqW39cnB-2iNNAeXq1gfVvoyDZAqM70HIX9OBmyv3Q",
  "gameListsBrand": "v3.5.0--cdEgfVQjEbbU2H9y_EKxxO3KHoLMjuTRh7dMG73SJtI",
  "winnersBrand": "v3.5.0--8fDG8dXwIC1W53mJDqITTIVSV_jZhzw3fyaqrgupykM",
  "vendorsListsBrand": "v3.5.0--fCqsEDZxuBjhCskL_fAigLH1tIAXYqNLcJIdxYXtC94",
  "vendorsItemsBrand": "v3.5.0--wdlEH7aAiqaoxbS4Q5UQqjCWMfj0HURrndfOtZ9tpSA",
  "generalConsentsBrand": "v3.5.0--8tN7gqLv5HRXei0h_nV7yI59eIU3XC35K1Vqt3QffXE",
  "gameTilesBrand": "v3.5.0--yiPTq2C7Fpm9tBYy8JUa6STMkuyKDK6UEvGUkDpY9Cc",
  "faqsItemsBrand": "v3.5.0--nFDlI8OalftTpjf63tgwpUI0TTi7zSNsFHQWiLdLkIY",
  "faqsSectionsBrand": "v3.5.0--UENDDnBRXBCqZHlA3WDIyVw2ZmqQjuIIQorVvtONZ_k",
  "faqsCollectionsBrand": "v3.5.0--tGp6XlYRQl4-ewm8maum4dhHr856-lgeSzClZNvf9eg",
  "blogsPostsBrand": "v3.5.0--IwT0zrNnkdKUMOvy9Q4MJlIuKn8a1n1PfuokuIB8BeI",
  "consentsBrand": "v3.5.0--Ulk624aHVxTu5hZjbcK8Rrk2T6YnV_OARUVD3z2BOlw",
  "pressPostsBrand": "v3.5.0--dOt3k4jnRF9giGnOoJXnCKiFB57JvU5P6tkELWjCsZU",
  "pagesBrand": "v3.5.0--xQ4LPAz6MGxRKycJ0P8W_AlqEwKguQj9U2Lbjs2Gn64",
  "saferGamblingQasRegion": "v3.5.0--s8I6ZqsLgNAKcL2xolGOZiM0l66p1UXPIilnF4FgoQ0",
  "saferGamblingPathsRegion": "v3.5.0--ptYo67BqobIJw1dYm4IUbc1y08YUEN8aIJxhx0VXboo",
  "saferGamblingRegion": "v3.5.0--D5kZcAuRTitAf9NJSGxVzpndeCTN2dZhrPzDgJ61bgc",
  "gamePagesRegion": "v3.5.0--4Dqb_7PFVOkTvZwDhBdqTcl19Xa5PADKqYmMP6Bc28g",
  "blogsTagsRegion": "v3.5.0--H_xdHBhv8qbhOHRrnPmjRT1oYxFC_sON3OjLfrygjXo",
  "pressTagsRegion": "v3.5.0--6enjceAnXhixVJDdWUcsUJ-ZcTMc1UW6DyRwKUHoIKQ",
  "gameListsRegion": "v3.5.0--ztNPfFBULsKnlCWv3Lp2QXedDTpJl-s9T6FigLz0E5k",
  "winnersRegion": "v3.5.0--pCZXdqKhWBMuHgSnzPeRBURJkWgeFf-V-nLkG_MFqXU",
  "vendorsListsRegion": "v3.5.0--0oET_yDG_sgFWuGYEGksQ2l7fs1UaradpYRyK9ibBJ4",
  "vendorsItemsRegion": "v3.5.0--VqciSvOCsYwtBCWy_YCxh0WOyxGyach9C5C5e9Qu4_k",
  "generalConsentsRegion": "v3.5.0--f4tqJRkAzvvbIE0hSP_gYbaD9H13fpVHjH2dTAnj1a8",
  "gameTilesRegion": "v3.5.0--JJiL5Gl3fiBFqMA5gdSm_Qs6yJ7HD9z3DbkGYI8AT_Q",
  "faqsItemsRegion": "v3.5.0--bJgc5iMft_d2uRrD2DyfRZEwChKrrFQJJDdqdaiicdk",
  "faqsSectionsRegion": "v3.5.0--GDXE3i9ibkYwZh6BTTzruULkYaaFKRph0EDnheyd8DU",
  "faqsCollectionsRegion": "v3.5.0--W_PFH9tMgvspFf2f1FBh9yZCZjoMa5GPDyPG9fPLWS0",
  "blogsPostsRegion": "v3.5.0--utpSLz6ufwroff38igXqlUKY9_xcRPWJu25SwlZmKNs",
  "consentsRegion": "v3.5.0--VUhZY0xVwmPVkDIxkPa2lO9LMhr75k1JIoYi-GJ_Rf8",
  "pressPostsRegion": "v3.5.0--fFTi-oJ36IL2Bvx3kCUQfeSzZnG0fiCQS4jC15lBdRM",
  "pagesRegion": "v3.5.0--Jkzc7_W9R9Ldw_vwBbQOfKLy_33rvNR46yEH1yZaajk",
  "saferGamblingQasBase": "v3.5.0--httWDEfB0ifvfLiIDsXUesXrQg7wsnGh2Vx9StRoS_I",
  "saferGamblingPathsBase": "v3.5.0--80KbrcL540R8h_P0c0g7G_XL7Y6-nw0oQYo5QiD1Qtg",
  "saferGamblingBase": "v3.5.0--rluSlVpL9itqgmKmRgnxeho27DJ8Kg_SZ04sAlL4lyE",
  "gamePagesBase": "v3.5.0--d4rGdj_2LXrZ0OgUZ2nXmYXFfNlvNZ4jfvuxyOq79DE",
  "blogsTagsBase": "v3.5.0--UtdLJfUObfml5rxegaDuwr5obXj6Eo4cNikNnzddkds",
  "pressTagsBase": "v3.5.0--Kecb_lJgMj6ZHg8rVsIgJOb6tW7T9vkzAuL3ClxglNk",
  "gameListsBase": "v3.5.0--C9tAevskHwGUFgjd29-ST6acCXbXSJ0UPd-i6OWHIgE",
  "winnersBase": "v3.5.0--8IzxYcRsQ8mqqAlkGcfq6B9aTG6JwFN0yUV60VmCJfQ",
  "vendorsListsBase": "v3.5.0--ZWmTJ2dY-ey5YUXoD1yNAleX6AkZ6nxRu2uH884UPkc",
  "vendorsItemsBase": "v3.5.0--YvUtqm3RmCluLa4gsIx00YiSlJgeqZx-obmAzLA1wxs",
  "generalConsentsBase": "v3.5.0--Yt-ohEJaUlS-3crTJqU2LQtgpZHSpk4wdGRO7Bylcoo",
  "gameTilesBase": "v3.5.0--x9nAnM-WJsKNhJutc56vnL591zN55O1i2xk01p0ou-4",
  "faqsItemsBase": "v3.5.0--kN8jhJ9bvpkkMkK_zNh_qjxoHi7e579Usoqbq9upKJc",
  "faqsSectionsBase": "v3.5.0--xCdwBlp5NUGAxPZBdPW3bZMg1I2cOMiNdenYqz-mSjs",
  "faqsCollectionsBase": "v3.5.0--F5JJjq6of78RzjZ3V9PO6u9igW9dAHUQobKNbgCEjSQ",
  "blogsPostsBase": "v3.5.0--5CWNjh47ERjigoTG580TAhviR7E-QVD1bBFgVCgyV8Y",
  "consentsBase": "v3.5.0--wTQ8TNHjsb2rreJCw_2IwpbrHWzTih4Lc46CRQeG5vg",
  "pressPostsBase": "v3.5.0--SjDOOKCcdAQgLdfMAc9SiVKmQBTGB2S6gPTJzYZYz80",
  "pagesBase": "v3.5.0--CGesy2f15MAYYLrQof472gFRmjZkm_A2Cw1u63g2tSw"
}
export const checksumsStructure = {
  "saferGamblingQasBrand": "8hnfP64Qefq7XkHc5kBsEABQqsaXeOU9Tz_ZeJMWsMQ",
  "saferGamblingPathsBrand": "V8aCm-2pgU046RQEgyojNPAzloM773quBjimmvgkyZc",
  "saferGamblingBrand": "qqfQllZxxAqmVleX8sQddlx94O0Hsp-Ky6q8op09HQ0",
  "gamePagesBrand": "zQo9snQoWpNOlykgQc45pbk-pWDq9yBJ4kM4n-qnVJo",
  "blogsTagsBrand": "KQtulL9O123ldTpFGWPr0TF4hX1ncu--DsIaKuS4ueM",
  "pressTagsBrand": "5sqW39cnB-2iNNAeXq1gfVvoyDZAqM70HIX9OBmyv3Q",
  "gameListsBrand": "chhJ872BasmiA27HWWNQkwf2cpOsBOD-9njPthjeiUQ",
  "winnersBrand": "B59D8fQ0yMbn6o4eKOwBSsmw3VgEGCjcPbDOI8DhEiI",
  "vendorsListsBrand": "EDUmxw74zhJcM2wwtU-U7HFj69Z7OyDoK4jBqPf5q60",
  "vendorsItemsBrand": "wdlEH7aAiqaoxbS4Q5UQqjCWMfj0HURrndfOtZ9tpSA",
  "generalConsentsBrand": "8tN7gqLv5HRXei0h_nV7yI59eIU3XC35K1Vqt3QffXE",
  "gameTilesBrand": "yiPTq2C7Fpm9tBYy8JUa6STMkuyKDK6UEvGUkDpY9Cc",
  "faqsItemsBrand": "nFDlI8OalftTpjf63tgwpUI0TTi7zSNsFHQWiLdLkIY",
  "faqsSectionsBrand": "bkqzP_nV3xdNrhhU9FPOifCE-dlyuMDucLfLwl6v6Gc",
  "faqsCollectionsBrand": "eG1vBbU7o4WQczWLKmtRapymnfZn9Bv8LxRJ-FwnpQc",
  "blogsPostsBrand": "IwT0zrNnkdKUMOvy9Q4MJlIuKn8a1n1PfuokuIB8BeI",
  "consentsBrand": "uU2misgvxAzeXrvY-s2b1f5gXWTa9BouPQC-bnNCzd8",
  "pressPostsBrand": "dOt3k4jnRF9giGnOoJXnCKiFB57JvU5P6tkELWjCsZU",
  "pagesBrand": "Qfp8vEcBM13qEyEp58Gt_mdkw2_kgofvzPJ5ToFgLM0",
  "saferGamblingQasRegion": "ajkHn-Lvbc4l_OeBrDLLgiRX8AZER8cgZ9o-42KOETA",
  "saferGamblingPathsRegion": "-Nq-w7QPz9Jxd5LYzdUHhX8QwzXR4KnsQXmHfr_wieU",
  "saferGamblingRegion": "s6E4VolMs2rJWvSEjvSpeLig8hBeE4nHHBS--vXxsCM",
  "gamePagesRegion": "eFsw2zJI7deT1LXNGVX0mqQVWaxa0OcT7odA__qK1u0",
  "blogsTagsRegion": "H_xdHBhv8qbhOHRrnPmjRT1oYxFC_sON3OjLfrygjXo",
  "pressTagsRegion": "6enjceAnXhixVJDdWUcsUJ-ZcTMc1UW6DyRwKUHoIKQ",
  "gameListsRegion": "ztNPfFBULsKnlCWv3Lp2QXedDTpJl-s9T6FigLz0E5k",
  "winnersRegion": "pCZXdqKhWBMuHgSnzPeRBURJkWgeFf-V-nLkG_MFqXU",
  "vendorsListsRegion": "0oET_yDG_sgFWuGYEGksQ2l7fs1UaradpYRyK9ibBJ4",
  "vendorsItemsRegion": "eRiW6i_JnZxVG9GSKZRdS0wavtStXzkJuCHEKxNOmLc",
  "generalConsentsRegion": "TesDz27A6V5KI7Hun4VsFa95HxgenoLrDkRirWxDy2M",
  "gameTilesRegion": "GIfui7c7pYaD1rnpywFIwr38XKOEmJQ5RFB_F75fXl8",
  "faqsItemsRegion": "jdXog1g9Q4HaqYOPZkZmQuZE8GUIwxAEIV52xz41Mp4",
  "faqsSectionsRegion": "GDXE3i9ibkYwZh6BTTzruULkYaaFKRph0EDnheyd8DU",
  "faqsCollectionsRegion": "W_PFH9tMgvspFf2f1FBh9yZCZjoMa5GPDyPG9fPLWS0",
  "blogsPostsRegion": "utpSLz6ufwroff38igXqlUKY9_xcRPWJu25SwlZmKNs",
  "consentsRegion": "IkHGxopENOY-Y-djipRygmGD7JmKM1bCf6ZUPDi_JCs",
  "pressPostsRegion": "fFTi-oJ36IL2Bvx3kCUQfeSzZnG0fiCQS4jC15lBdRM",
  "pagesRegion": "Jkzc7_W9R9Ldw_vwBbQOfKLy_33rvNR46yEH1yZaajk",
  "saferGamblingQasBase": "httWDEfB0ifvfLiIDsXUesXrQg7wsnGh2Vx9StRoS_I",
  "saferGamblingPathsBase": "80KbrcL540R8h_P0c0g7G_XL7Y6-nw0oQYo5QiD1Qtg",
  "saferGamblingBase": "rluSlVpL9itqgmKmRgnxeho27DJ8Kg_SZ04sAlL4lyE",
  "gamePagesBase": "d4rGdj_2LXrZ0OgUZ2nXmYXFfNlvNZ4jfvuxyOq79DE",
  "blogsTagsBase": "UtdLJfUObfml5rxegaDuwr5obXj6Eo4cNikNnzddkds",
  "pressTagsBase": "Kecb_lJgMj6ZHg8rVsIgJOb6tW7T9vkzAuL3ClxglNk",
  "gameListsBase": "C9tAevskHwGUFgjd29-ST6acCXbXSJ0UPd-i6OWHIgE",
  "winnersBase": "8IzxYcRsQ8mqqAlkGcfq6B9aTG6JwFN0yUV60VmCJfQ",
  "vendorsListsBase": "ZWmTJ2dY-ey5YUXoD1yNAleX6AkZ6nxRu2uH884UPkc",
  "vendorsItemsBase": "YvUtqm3RmCluLa4gsIx00YiSlJgeqZx-obmAzLA1wxs",
  "generalConsentsBase": "Yt-ohEJaUlS-3crTJqU2LQtgpZHSpk4wdGRO7Bylcoo",
  "gameTilesBase": "x9nAnM-WJsKNhJutc56vnL591zN55O1i2xk01p0ou-4",
  "faqsItemsBase": "kN8jhJ9bvpkkMkK_zNh_qjxoHi7e579Usoqbq9upKJc",
  "faqsSectionsBase": "xCdwBlp5NUGAxPZBdPW3bZMg1I2cOMiNdenYqz-mSjs",
  "faqsCollectionsBase": "F5JJjq6of78RzjZ3V9PO6u9igW9dAHUQobKNbgCEjSQ",
  "blogsPostsBase": "5CWNjh47ERjigoTG580TAhviR7E-QVD1bBFgVCgyV8Y",
  "consentsBase": "wTQ8TNHjsb2rreJCw_2IwpbrHWzTih4Lc46CRQeG5vg",
  "pressPostsBase": "SjDOOKCcdAQgLdfMAc9SiVKmQBTGB2S6gPTJzYZYz80",
  "pagesBase": "CGesy2f15MAYYLrQof472gFRmjZkm_A2Cw1u63g2tSw"
}

export const tables = {
  "saferGamblingQasBrand": "_content_saferGamblingQasBrand",
  "saferGamblingPathsBrand": "_content_saferGamblingPathsBrand",
  "saferGamblingBrand": "_content_saferGamblingBrand",
  "gamePagesBrand": "_content_gamePagesBrand",
  "blogsTagsBrand": "_content_blogsTagsBrand",
  "pressTagsBrand": "_content_pressTagsBrand",
  "gameListsBrand": "_content_gameListsBrand",
  "winnersBrand": "_content_winnersBrand",
  "vendorsListsBrand": "_content_vendorsListsBrand",
  "vendorsItemsBrand": "_content_vendorsItemsBrand",
  "generalConsentsBrand": "_content_generalConsentsBrand",
  "gameTilesBrand": "_content_gameTilesBrand",
  "faqsItemsBrand": "_content_faqsItemsBrand",
  "faqsSectionsBrand": "_content_faqsSectionsBrand",
  "faqsCollectionsBrand": "_content_faqsCollectionsBrand",
  "blogsPostsBrand": "_content_blogsPostsBrand",
  "consentsBrand": "_content_consentsBrand",
  "pressPostsBrand": "_content_pressPostsBrand",
  "pagesBrand": "_content_pagesBrand",
  "saferGamblingQasRegion": "_content_saferGamblingQasRegion",
  "saferGamblingPathsRegion": "_content_saferGamblingPathsRegion",
  "saferGamblingRegion": "_content_saferGamblingRegion",
  "gamePagesRegion": "_content_gamePagesRegion",
  "blogsTagsRegion": "_content_blogsTagsRegion",
  "pressTagsRegion": "_content_pressTagsRegion",
  "gameListsRegion": "_content_gameListsRegion",
  "winnersRegion": "_content_winnersRegion",
  "vendorsListsRegion": "_content_vendorsListsRegion",
  "vendorsItemsRegion": "_content_vendorsItemsRegion",
  "generalConsentsRegion": "_content_generalConsentsRegion",
  "gameTilesRegion": "_content_gameTilesRegion",
  "faqsItemsRegion": "_content_faqsItemsRegion",
  "faqsSectionsRegion": "_content_faqsSectionsRegion",
  "faqsCollectionsRegion": "_content_faqsCollectionsRegion",
  "blogsPostsRegion": "_content_blogsPostsRegion",
  "consentsRegion": "_content_consentsRegion",
  "pressPostsRegion": "_content_pressPostsRegion",
  "pagesRegion": "_content_pagesRegion",
  "saferGamblingQasBase": "_content_saferGamblingQasBase",
  "saferGamblingPathsBase": "_content_saferGamblingPathsBase",
  "saferGamblingBase": "_content_saferGamblingBase",
  "gamePagesBase": "_content_gamePagesBase",
  "blogsTagsBase": "_content_blogsTagsBase",
  "pressTagsBase": "_content_pressTagsBase",
  "gameListsBase": "_content_gameListsBase",
  "winnersBase": "_content_winnersBase",
  "vendorsListsBase": "_content_vendorsListsBase",
  "vendorsItemsBase": "_content_vendorsItemsBase",
  "generalConsentsBase": "_content_generalConsentsBase",
  "gameTilesBase": "_content_gameTilesBase",
  "faqsItemsBase": "_content_faqsItemsBase",
  "faqsSectionsBase": "_content_faqsSectionsBase",
  "faqsCollectionsBase": "_content_faqsCollectionsBase",
  "blogsPostsBase": "_content_blogsPostsBase",
  "consentsBase": "_content_consentsBase",
  "pressPostsBase": "_content_pressPostsBase",
  "pagesBase": "_content_pagesBase",
  "info": "_content_info"
}

export default {
  "saferGamblingQasBrand": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "ctas": "json",
      "date": "date",
      "description": "string",
      "expandableTextBlocks": "json",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "sortOrder": "number",
      "stem": "string",
      "video_id": "string"
    }
  },
  "saferGamblingPathsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "category": "string",
      "extension": "string",
      "header": "string",
      "icon": "string",
      "meta": "json",
      "path": "string",
      "sortOrder": "number",
      "stem": "string"
    }
  },
  "saferGamblingBrand": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "gamePagesBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "dynamicContent": "json",
      "extension": "string",
      "headline": "json",
      "hero": "json",
      "introText": "json",
      "meta": "json",
      "overviewDescription": "json",
      "overviewHeadline": "json",
      "publishAt": "json",
      "seo": "string",
      "seoName": "string",
      "showInOverview": "json",
      "slug": "string",
      "stem": "string",
      "tags": "json"
    }
  },
  "blogsTagsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "pressTagsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "gameListsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "animateIn": "boolean",
      "category": "string",
      "extension": "string",
      "forceShowAllButton": "boolean",
      "gameTiles": "json",
      "inlineRows": "number",
      "key": "string",
      "limitList": "boolean",
      "meta": "json",
      "numberOfGames": "number",
      "showAllButton": "boolean",
      "showAllLink": "string",
      "showAllText": "string",
      "showMoreButton": "boolean",
      "showNewGames": "boolean",
      "skeletons": "number",
      "sort": "string",
      "stem": "string",
      "totalGames": "number",
      "videoEnabled": "boolean"
    }
  },
  "winnersBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "json",
      "extension": "string",
      "fadeColor": "json",
      "flippedOrder": "json",
      "gameTiles": "json",
      "horizontal": "json",
      "key": "string",
      "meta": "json",
      "shinyCombinedJackpot": "json",
      "showJackpotWinner": "json",
      "stem": "string",
      "titleColor": "json",
      "winnerListLimit": "json",
      "winnerTileSkeletons": "json"
    }
  },
  "vendorsListsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "meta": "json",
      "stem": "string",
      "vendors": "json"
    }
  },
  "vendorsItemsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "providerSlug": "string",
      "slug": "string",
      "stem": "string",
      "useProviderSlug": "json"
    }
  },
  "generalConsentsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "header": "string",
      "meta": "json",
      "publishAt": "json",
      "sections": "json",
      "stem": "string",
      "subHeader": "json",
      "version": "string"
    }
  },
  "gameTilesBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "slug": "string",
      "stem": "string"
    }
  },
  "faqsItemsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "answer": "json",
      "extension": "string",
      "meta": "json",
      "question": "string",
      "routeHash": "string",
      "stem": "string"
    }
  },
  "faqsSectionsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "faqItems": "json",
      "meta": "json",
      "stem": "string"
    }
  },
  "faqsCollectionsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "faqSections": "json",
      "meta": "json",
      "stem": "string"
    }
  },
  "blogsPostsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "SEO": "string",
      "content": "json",
      "extension": "string",
      "hideInBlogList": "boolean",
      "label": "string",
      "media": "json",
      "meta": "json",
      "publishAt": "json",
      "slug": "string",
      "stem": "string",
      "subtitle": "string",
      "tags": "json",
      "visibility": "string"
    }
  },
  "consentsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "content": "json",
      "extension": "string",
      "meta": "json",
      "publishAt": "json",
      "stem": "string",
      "type": "string",
      "version": "string"
    }
  },
  "pressPostsBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "SEO": "string",
      "author": "string",
      "content": "json",
      "extension": "string",
      "label": "string",
      "media": "json",
      "meta": "json",
      "publishAt": "json",
      "slug": "string",
      "stem": "string",
      "tags": "json"
    }
  },
  "pagesBrand": {
    "type": "data",
    "fields": {
      "id": "string",
      "dynamicContent": "json",
      "extension": "string",
      "meta": "json",
      "publishAt": "json",
      "seo": "string",
      "seoName": "string",
      "stem": "string"
    }
  },
  "saferGamblingQasRegion": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "ctas": "json",
      "date": "date",
      "description": "string",
      "expandableTextBlocks": "json",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "sortOrder": "number",
      "stem": "string",
      "video_id": "string"
    }
  },
  "saferGamblingPathsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "category": "string",
      "extension": "string",
      "header": "string",
      "icon": "string",
      "meta": "json",
      "path": "string",
      "sortOrder": "number",
      "stem": "string"
    }
  },
  "saferGamblingRegion": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "gamePagesRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "dynamicContent": "json",
      "extension": "string",
      "headline": "json",
      "hero": "json",
      "introText": "json",
      "meta": "json",
      "overviewDescription": "json",
      "overviewHeadline": "json",
      "publishAt": "json",
      "seo": "string",
      "seoName": "string",
      "showInOverview": "json",
      "slug": "string",
      "stem": "string",
      "tags": "json"
    }
  },
  "blogsTagsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "pressTagsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "gameListsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "animateIn": "boolean",
      "category": "string",
      "extension": "string",
      "forceShowAllButton": "boolean",
      "gameTiles": "json",
      "inlineRows": "number",
      "key": "string",
      "limitList": "boolean",
      "meta": "json",
      "numberOfGames": "number",
      "showAllButton": "boolean",
      "showAllLink": "string",
      "showAllText": "string",
      "showMoreButton": "boolean",
      "showNewGames": "boolean",
      "skeletons": "number",
      "sort": "string",
      "stem": "string",
      "totalGames": "number",
      "videoEnabled": "boolean"
    }
  },
  "winnersRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "json",
      "extension": "string",
      "fadeColor": "json",
      "flippedOrder": "json",
      "gameTiles": "json",
      "horizontal": "json",
      "key": "string",
      "meta": "json",
      "shinyCombinedJackpot": "json",
      "showJackpotWinner": "json",
      "stem": "string",
      "titleColor": "json",
      "winnerListLimit": "json",
      "winnerTileSkeletons": "json"
    }
  },
  "vendorsListsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "meta": "json",
      "stem": "string",
      "vendors": "json"
    }
  },
  "vendorsItemsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "providerSlug": "string",
      "slug": "string",
      "stem": "string",
      "useProviderSlug": "json"
    }
  },
  "generalConsentsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "header": "string",
      "meta": "json",
      "publishAt": "json",
      "sections": "json",
      "stem": "string",
      "subHeader": "json",
      "version": "string"
    }
  },
  "gameTilesRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "slug": "string",
      "stem": "string"
    }
  },
  "faqsItemsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "answer": "json",
      "extension": "string",
      "meta": "json",
      "question": "string",
      "routeHash": "string",
      "stem": "string"
    }
  },
  "faqsSectionsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "faqItems": "json",
      "meta": "json",
      "stem": "string"
    }
  },
  "faqsCollectionsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "faqSections": "json",
      "meta": "json",
      "stem": "string"
    }
  },
  "blogsPostsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "SEO": "string",
      "content": "json",
      "extension": "string",
      "hideInBlogList": "boolean",
      "label": "string",
      "media": "json",
      "meta": "json",
      "publishAt": "json",
      "slug": "string",
      "stem": "string",
      "subtitle": "string",
      "tags": "json",
      "visibility": "string"
    }
  },
  "consentsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "content": "json",
      "extension": "string",
      "meta": "json",
      "publishAt": "json",
      "stem": "string",
      "type": "string",
      "version": "string"
    }
  },
  "pressPostsRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "SEO": "string",
      "author": "string",
      "content": "json",
      "extension": "string",
      "label": "string",
      "media": "json",
      "meta": "json",
      "publishAt": "json",
      "slug": "string",
      "stem": "string",
      "tags": "json"
    }
  },
  "pagesRegion": {
    "type": "data",
    "fields": {
      "id": "string",
      "dynamicContent": "json",
      "extension": "string",
      "meta": "json",
      "publishAt": "json",
      "seo": "string",
      "seoName": "string",
      "stem": "string"
    }
  },
  "saferGamblingQasBase": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "ctas": "json",
      "date": "date",
      "description": "string",
      "expandableTextBlocks": "json",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "sortOrder": "number",
      "stem": "string",
      "video_id": "string"
    }
  },
  "saferGamblingPathsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "category": "string",
      "extension": "string",
      "header": "string",
      "icon": "string",
      "meta": "json",
      "path": "string",
      "sortOrder": "number",
      "stem": "string"
    }
  },
  "saferGamblingBase": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "gamePagesBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "dynamicContent": "json",
      "extension": "string",
      "headline": "json",
      "hero": "json",
      "introText": "json",
      "meta": "json",
      "overviewDescription": "json",
      "overviewHeadline": "json",
      "publishAt": "json",
      "seo": "string",
      "seoName": "string",
      "showInOverview": "json",
      "slug": "string",
      "stem": "string",
      "tags": "json"
    }
  },
  "blogsTagsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "pressTagsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "gameListsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "animateIn": "boolean",
      "category": "string",
      "extension": "string",
      "forceShowAllButton": "boolean",
      "gameTiles": "json",
      "inlineRows": "number",
      "key": "string",
      "limitList": "boolean",
      "meta": "json",
      "numberOfGames": "number",
      "showAllButton": "boolean",
      "showAllLink": "string",
      "showAllText": "string",
      "showMoreButton": "boolean",
      "showNewGames": "boolean",
      "skeletons": "number",
      "sort": "string",
      "stem": "string",
      "totalGames": "number",
      "videoEnabled": "boolean"
    }
  },
  "winnersBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "json",
      "extension": "string",
      "fadeColor": "json",
      "flippedOrder": "json",
      "gameTiles": "json",
      "horizontal": "json",
      "key": "string",
      "meta": "json",
      "shinyCombinedJackpot": "json",
      "showJackpotWinner": "json",
      "stem": "string",
      "titleColor": "json",
      "winnerListLimit": "json",
      "winnerTileSkeletons": "json"
    }
  },
  "vendorsListsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "meta": "json",
      "stem": "string",
      "vendors": "json"
    }
  },
  "vendorsItemsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "providerSlug": "string",
      "slug": "string",
      "stem": "string",
      "useProviderSlug": "json"
    }
  },
  "generalConsentsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "header": "string",
      "meta": "json",
      "publishAt": "json",
      "sections": "json",
      "stem": "string",
      "subHeader": "json",
      "version": "string"
    }
  },
  "gameTilesBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "slug": "string",
      "stem": "string"
    }
  },
  "faqsItemsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "answer": "json",
      "extension": "string",
      "meta": "json",
      "question": "string",
      "routeHash": "string",
      "stem": "string"
    }
  },
  "faqsSectionsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "faqItems": "json",
      "meta": "json",
      "stem": "string"
    }
  },
  "faqsCollectionsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "extension": "string",
      "faqSections": "json",
      "meta": "json",
      "stem": "string"
    }
  },
  "blogsPostsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "SEO": "string",
      "content": "json",
      "extension": "string",
      "hideInBlogList": "boolean",
      "label": "string",
      "media": "json",
      "meta": "json",
      "publishAt": "json",
      "slug": "string",
      "stem": "string",
      "subtitle": "string",
      "tags": "json",
      "visibility": "string"
    }
  },
  "consentsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "content": "json",
      "extension": "string",
      "meta": "json",
      "publishAt": "json",
      "stem": "string",
      "type": "string",
      "version": "string"
    }
  },
  "pressPostsBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "SEO": "string",
      "author": "string",
      "content": "json",
      "extension": "string",
      "label": "string",
      "media": "json",
      "meta": "json",
      "publishAt": "json",
      "slug": "string",
      "stem": "string",
      "tags": "json"
    }
  },
  "pagesBase": {
    "type": "data",
    "fields": {
      "id": "string",
      "dynamicContent": "json",
      "extension": "string",
      "meta": "json",
      "publishAt": "json",
      "seo": "string",
      "seoName": "string",
      "stem": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}